
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Job } from '@/domains/global/models'

import ActionDropdown from '@/domains/global/components/ActionDropdown.vue'
import ConfirmModal from '@/domains/global/components/ConfirmModal.vue'
import AbandonJobModal from '@/domains/jobs/components/AbandonJobModal.vue'
import BannedProviderListModal from '@/domains/jobs/components/BannedProviderList.vue'
import axios from 'axios'
import { consumeError, viewOnly } from '@/domains/global/utils'
import * as Sentry from '@sentry/vue'

@Component({
  components: { ActionDropdown, AbandonJobModal, BannedProviderListModal }
})
export default class JobActionButtons extends Vue {
  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  get agencyId() {
    return this.$store.state.auth.agencyId
  }

  get operatingAsCustomer () {
    return this.job.type === 'agency' && this.job.brokerId === this.agencyId
  }

  get isDraft () {
    return ['draft', 'inactive'].includes(this.job.status)
  }

  get isViewOnly() {
    return viewOnly(this.job)
  }

  get dropdownActions() {
    return [
      { text: 'View Banned Providers', method: this.openBannedListModal.bind(this) }
    ]
  }

  get unassignConfirmModal() {
    return this.$refs.unassignConfirmModal as ConfirmModal<Job>
  }

  get abandonModal() {
    return this.$refs.abandonModal as AbandonJobModal
  }

  get bannedListModal() {
    return this.$refs.bannedListModal as BannedProviderListModal
  }

  get isComplete() {
    if (!this.job) {
      return false
    }
    return ['completed', 'abandoned'].includes(this.job.status)
  }

  openBannedListModal() {
    this.bannedListModal.open(this.job.id)
  }

  unassignJob(job: Job) {
    this.$emit('unassign', job)
  }

  abandonJob(data: { job: Job, reason: string }) {
    this.$emit('abandon', data)
  }

  async sendJobLink() {
    try {
      await axios.post(`jobs/${this.job.id}/send-link`)
      this.$store.dispatch('success', 'Successfully sent customer job link')
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
